
import { mapGetters } from "vuex"
import copyToClipboard from "copy-to-clipboard"
import type { MetaInfo } from "vue-meta"
import { defaults } from "sanitize-html"
import backButtonMixin from "@/mixins/back-button"
import { getOgImgMeta } from "@/utils/meta"
import socials from "@/const/sharing.json"
import type { FullNewsItem } from "@/types/api/news"

export default backButtonMixin.extend({
  async asyncData ({ route, redirect, app, $api }) {
    const goUp = () => redirect(app.localePath("/news"))

    const alias = route.params.alias
    if (!alias) return goUp()

    const [res, err] = await $api.news.getNewsItem(alias)
    if (err || !res) return goUp()

    return { item: res }
  },

  data: () => ({
    item: null as Nullable<FullNewsItem>,
    socials,
  }),

  head () {
    const { item } = this
    if (!item) return {}

    const head: MetaInfo = {
      title: this.getTitle(item.title),
    }

    head.meta = [
      { hid: "description", name: "description", content: item.shortText },
    ]
    const img = this.item?.image.url
    if (img) head.meta = head.meta.concat(getOgImgMeta(img))
    return head
  },

  computed: {
    ...mapGetters("app", ["getTitle"]),

    url (): string { return process.browser ? window.location.href : "" },

    iFrameOptions () {
      return {
        allowedTags: defaults.allowedTags.concat(["img", "iframe", "a"]),
        allowedAttributes: {
          iframe: ["src", "allow", "frameborder"],
          a: ["href"],
        },
      }
    },
  },

  methods: {
    share () {
      copyToClipboard(this.url)
      this.$notify({
        title: "",
        message: this.$t("common.copiedToClipboard") as string,
        type: "success",
      })
    },
  },
})
